import { createHttpEndpoint } from '../../utils'

import type { GetMarketsWithSubMarkets, GetShippingRules } from './rules.types'

/**
 * Fetch shipping rules for a seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/shipping-service-delivery-methods-api/definition#/delivery-methods/delivery_methods_v1_get_seller_delivery_methods}
 */
export const getShippingRules = createHttpEndpoint<GetShippingRules>({
  method: 'GET',
  operationId: 'getShippingRules',
  path: '/bm/delivery-methods/v2/seller/:sellerId/shipping-rules',
})

/**
 * Create or update a shipping rule for a seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/shipping-service-delivery-methods-api/definition#/delivery-methods/delivery_methods_v1_post_shipping_rule}
 */
export const postShippingRule = createHttpEndpoint({
  method: 'POST',
  operationId: 'createOrUpdateShippingRule',
  path: '/bm/delivery-methods/v2/seller/:sellerId/shipping-rules',
})

/**
 * Delete a shipping rule from a seller.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/shipping-service-delivery-methods-api/definition#/delivery-methods/delivery_methods_v1_delete_shipping_rule}
 */
export const deleteShippingRule = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteShippingRule',
  path: '/bm/delivery-methods/v1/seller/:sellerId/shipping-rules/:shippingRuleId',
})

export const getMarketsWithSubMarkets =
  createHttpEndpoint<GetMarketsWithSubMarkets>({
    method: 'GET',
    operationId: 'getMarketsWithSubMarkets',
    path: '/bm/delivery-methods/v1/sub-markets',
  })
